export const MIN_USER_LEVEL = 0;
export const MAX_USER_LEVEL = 2;
export enum UserLevel {
	driver = 0,
	admin = 1,
	superAdmin = 2,
}

export interface User {
	id: number;
	username: string;
	name: string;
	surname: string;
	type: string;
	level: UserLevel;
	balance: number;
	created: string;
	created_by: number;
	removed: string | null;
	removed_by: number | null;
	logged: string;
	unsettled: number;
	uncollectedCash?: number;
}
